var map = {
	"./apiParamsInitialization.js": 23,
	"./gameParameters.js": 24,
	"./httpResponse.js": 25,
	"./messageHelper.js": 26,
	"./notificationType.js": 27,
	"./notificationsName.js": 28,
	"./resources.js": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;